var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.tickerTape = function (widget, chart, data, metadata) {
    setTimeout(function () {
        MDB.Charts.emptyChartAndMakeVisible(widget, chart);

        var kendoConfig = metadata.KendoConfig || {};
        var marquee = widget.find('marquee');

        if(marquee.length === 0) {
            marquee = $('<marquee />');
            chart.append(marquee);
        };
		
        var txt = loadText(widget, data);
        var textLoader = kendoConfig.htmlAllowed ? 'html' : 'text';

        if(txt) {
            marquee[textLoader](txt);
        }
        if(kendoConfig.style) {
            if(typeof kendoConfig.style === 'string'){
                kendoConfig.style = JSON.parse(kendoConfig.style);
            }

            marquee.css(kendoConfig.style)
        }

        //Todo: Move to generic widget renderer
        if(kendoConfig.refreshInterval){
            var multiplier = 1;

            if(kendoConfig.refreshIntervalType){
                switch(kendoConfig.refreshIntervalType){
                case 'second':
                    multiplier = 1000;
                    break;
                case 'millisecond':
                    multiplier = 1;
                    break;
                default:
                    console.warn('Unknown refresh interval type: ' + kendoConfig.refreshIntervalType);
                }
            }

            var refreshInterval = kendoConfig.refreshInterval * multiplier;

            //Min 10 seconds
            if(refreshInterval < 10000) {
                refreshInterval = 10000;
            }

            setTimeout(function(){
                widget.mdbRefreshWidget();
            }, refreshInterval);
        }
    }, 0);

    function loadText(widget, data){
        //var prev = widget.data('prev-text') || '';

        if(data === undefined || data[0] === undefined) {
            return null;
        }
				
        var keys = _.filter(Object.keys(data), function(key){
            return !isNaN(key);
        });

        var dataKeys = Object.keys(data[keys[0]]);
        var textColumn = dataKeys.length ? dataKeys[0] : undefined;

        if(textColumn === undefined) {
            return null;
        }

        return _.map(keys, function(key){
            return data[key][textColumn];
        }).join(' • ');
    }
};